
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-policy",
      function () {
        return require("private-next-pages/business-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-policy"])
      });
    }
  